/* cm-mmc.js (v5, 2026-10-13): behaviour for the sections ported from mymobilitycenter.com
   (reveal on scroll, the house / bus / community diagrams, the logo and social marquees).
   Ported from MMC's assets/js/mmc.js (initReveal, initOneHouse, initMarquee). */
(function () {
  function motionOff() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function initReveal() {
    var t = document.querySelectorAll('.cm-mmc .mmc-reveal, .cm-mmc .mmc-stagger, .cm-mmc .mmc-checklist');
    if (!('IntersectionObserver' in window) || motionOff()) { Array.prototype.forEach.call(t, function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(t, function (el) { io.observe(el); });
    // never leave anything hidden: after load, show whatever is still waiting
    window.addEventListener('load', function () { setTimeout(function () { Array.prototype.forEach.call(document.querySelectorAll('.cm-mmc .mmc-reveal:not(.is-in), .cm-mmc .mmc-stagger:not(.is-in)'), function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1200); });
  }

  function initOneHouse(house) {
    var pins = Array.prototype.slice.call(house.querySelectorAll('.mmc-h-pin'));
    var zones = Array.prototype.slice.call(house.querySelectorAll('.mmc-h-zone[data-zone]'));
    var tabs = Array.prototype.slice.call(house.querySelectorAll('.mmc-house-tab'));
    var details = Array.prototype.slice.call(house.querySelectorAll('.mmc-house-detail'));
    function show(key) {
      pins.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pin') === key); });
      zones.forEach(function (z) { z.classList.toggle('is-active', z.getAttribute('data-zone') === key); });
      tabs.forEach(function (t) { var on = t.getAttribute('data-zone-to') === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      details.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-detail') === key); });
    }
    pins.forEach(function (p) { p.addEventListener('click', function () { show(p.getAttribute('data-pin')); }); });
    zones.forEach(function (z) { z.addEventListener('click', function () { show(z.getAttribute('data-zone')); }); z.style.cursor = 'pointer'; });
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-zone-to')); }); });
    var first = house.querySelector('.mmc-house-tab.is-active'); if (first) show(first.getAttribute('data-zone-to'));
  }

  function initMarquee() {
    Array.prototype.forEach.call(document.querySelectorAll('.cm-mmc [data-marquee]'), function (set) {
      var rows = set.querySelectorAll('.mmc-marquee');
      Array.prototype.forEach.call(rows, function (row) {
        var track = row.querySelector('.mmc-marquee-track');
        if (!track || track.dataset.cloned === '1') return;
        Array.prototype.slice.call(track.children).forEach(function (item) {
          var clone = item.cloneNode(true); clone.setAttribute('aria-hidden', 'true');
          if (clone.tagName === 'A') clone.setAttribute('tabindex', '-1');
          Array.prototype.forEach.call(clone.querySelectorAll('a'), function (a) { a.setAttribute('tabindex', '-1'); });
          track.appendChild(clone);
        });
        track.dataset.cloned = '1';
        var width = track.scrollWidth / 2;
        track.style.setProperty('--marquee-dur', Math.max(34, Math.round(width / 30)) + 's');
      });
      var pauseBtn = set.querySelector('[data-marquee-pause]'), prevBtn = set.querySelector('[data-marquee-prev]'), nextBtn = set.querySelector('[data-marquee-next]');
      function resume() {
        Array.prototype.forEach.call(rows, function (row) {
          var track = row.querySelector('.mmc-marquee-track');
          if (!track || track.dataset.offset === undefined) return;
          var half = track.scrollWidth / 2, done = half ? -parseFloat(track.dataset.offset) / half : 0;
          if (row.getAttribute('data-direction') === 'right') done = 1 - done;
          var dur = parseFloat(track.style.getPropertyValue('--marquee-dur')) || 64;
          delete track.dataset.offset; track.style.transition = ''; track.style.transform = ''; track.style.animation = ''; track.style.animationDelay = (-done * dur) + 's';
        });
      }
      function setPaused(state) { set.classList.toggle('is-paused', state); if (pauseBtn) pauseBtn.setAttribute('aria-pressed', state ? 'true' : 'false'); if (!state) resume(); }
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!set.classList.contains('is-paused')); });
      function step(dir) {
        setPaused(true);
        Array.prototype.forEach.call(rows, function (row) {
          var track = row.querySelector('.mmc-marquee-track'); if (!track) return;
          var reversed = row.getAttribute('data-direction') === 'right';
          var tile = track.querySelector('.mmc-logo-tile, .mmc-brand-tile, .mmc-social-chip');
          var stepBy = tile ? tile.getBoundingClientRect().width + 16 : 200, half = track.scrollWidth / 2, current;
          if (track.dataset.offset === undefined) { var m = window.getComputedStyle(track).transform; current = m && m !== 'none' ? new DOMMatrix(m).m41 : 0; } else current = parseFloat(track.dataset.offset);
          current += (reversed ? -dir : dir) * stepBy * 2;
          if (current > 0) current -= half; if (current < -half) current += half;
          track.dataset.offset = current; track.style.animation = 'none'; track.style.transition = 'transform .45s cubic-bezier(.2,.7,.3,1)'; track.style.transform = 'translate3d(' + current + 'px,0,0)';
        });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { step(1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(-1); });
      if (motionOff()) setPaused(true);
    });
  }

  function init() {
    initReveal();
    Array.prototype.forEach.call(document.querySelectorAll('.cm-mmc [data-house]'), initOneHouse);
    initMarquee();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
